// aiMessageActions.js — resolve Ai message.action payloads for chat UI

function cleanString(value) {
  return String(value || '').trim();
}

export function resolveDatabaseViewAction(message) {
  const action = message?.action && typeof message.action === 'object' ? message.action : null;
  if (!action || cleanString(action.kind) !== 'database_view') return null;

  const databaseKey = cleanString(action.collectionKey || action.databaseKey);
  if (!databaseKey) return null;

  const rawLabel = cleanString(action.label);

  return {
    databaseKey,
    collectionKey: databaseKey,
    typeKey: cleanString(action.typeKey),
    baseKey: cleanString(action.baseKey),
    label: rawLabel === 'View' || !rawLabel ? 'View Collection' : rawLabel,
  };
}

export function resolvePickRecordAction(message) {
  const action = message?.action && typeof message.action === 'object' ? message.action : null;
  if (!action || cleanString(action.kind) !== 'pick_record') return null;

  const options = (Array.isArray(action.options) ? action.options : [])
    .map((entry) => {
      const nodeKey = cleanString(entry?.nodeKey);
      if (!nodeKey) return null;
      const title = cleanString(entry?.title) || nodeKey;
      const typeLabel = cleanString(entry?.typeLabel) || 'Record';
      const subtitle = cleanString(entry?.subtitle);
      const typeKey = cleanString(entry?.typeKey || entry?.type);
      return {
        nodeKey,
        title,
        typeLabel,
        subtitle,
        ...(typeKey ? { typeKey } : {}),
        label: cleanString(entry?.label) || (typeLabel ? `${title} (${typeLabel})` : title),
      };
    })
    .filter(Boolean);

  if (options.length < 2) return null;

  const selectMode = cleanString(action.selectMode) === 'open_record'
    ? 'open_record'
    : 'resume';

  return {
    kind: 'pick_record',
    searchText: cleanString(action.searchText),
    selectMode,
    options,
  };
}

export function resolveRecordOpenAction(message) {
  const action = message?.action && typeof message.action === 'object' ? message.action : null;
  if (!action || cleanString(action.kind) !== 'record_open') return null;

  const nodeKey = cleanString(action.nodeKey);
  if (!nodeKey) return null;

  return {
    nodeKey,
    typeKey: cleanString(action.typeKey),
    baseKey: cleanString(action.baseKey),
    title: cleanString(action.title),
    label: cleanString(action.label) || 'Open',
    permalink: cleanString(action.permalink),
  };
}

export function resolveRecordOpenNode(message, surfaceNodes = []) {
  const action = resolveRecordOpenAction(message);
  if (!action) return null;

  const nodes = Array.isArray(surfaceNodes) ? surfaceNodes : [];
  const matched = nodes.find((node) => cleanString(node?.key || node?.id) === action.nodeKey);
  if (matched) return matched;

  return {
    key: action.nodeKey,
    type: action.typeKey || undefined,
    title: action.title || undefined,
  };
}

export function resolveAutomationSavedAction(message) {
  const action = message?.action && typeof message.action === 'object' ? message.action : null;
  if (!action || cleanString(action.kind) !== 'automation_saved') return null;

  const databaseKey = cleanString(action.databaseKey);
  const typeKey = cleanString(action.typeKey);
  const baseKey = cleanString(action.baseKey);
  if (!databaseKey || !typeKey || !baseKey) return null;

  const databaseView = action.databaseView && typeof action.databaseView === 'object'
    ? action.databaseView
    : null;

  return {
    databaseKey,
    typeKey,
    baseKey,
    ruleKey: cleanString(action.ruleKey),
    duplicate: Boolean(action.duplicate),
    label: cleanString(action.label) || 'Open automations',
    databaseView: databaseView ? {
      databaseKey: cleanString(databaseView.databaseKey) || databaseKey,
      typeKey: cleanString(databaseView.typeKey) || typeKey,
      baseKey: cleanString(databaseView.baseKey) || baseKey,
      label: cleanString(databaseView.label) || 'View Collection',
    } : null,
  };
}

export function resolveConversationOpenAction(message) {
  const action = message?.action && typeof message.action === 'object' ? message.action : null;
  if (!action || cleanString(action.kind) !== 'conversation_open') return null;

  const channelKey = cleanString(action.channelKey);
  if (!channelKey) return null;

  return {
    channelKey,
    baseKey: cleanString(action.baseKey),
    messageKey: cleanString(action.messageKey),
    threadRootKey: cleanString(action.threadRootKey),
    recipientName: cleanString(action.recipientName),
    label: cleanString(action.label) || 'Open conversation',
  };
}
